// extracted by mini-css-extract-plugin
module.exports = {"cell":"DocumentTypeCell_cell__2Eobj","link":"DocumentTypeCell_link__18CRE"};